<template>
    <div class="vrm-warning" :class="{ severe: severe }">
        <div class="vrm-warning__icon sg-vrm-icon_012_alarm-32px"></div>
        <div class="vrm-warning__text">
            <slot></slot>
        </div>
        <div
            v-if="onClickClose"
            class="vrm-warning__icon--close sg-vrm-icon_055_cross-16px"
            @click="onClickClose"
        ></div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('vrm-warning')
export default class VrmWarning extends Vue {
    @Prop({ default: false })
    severe;

    @Prop()
    onClickClose;
}
</script>
